import { useLazyContext } from "@redotech/react-util/context";
import { ConversationTagInput } from "@redotech/redo-merchant-support-app/conversation-tags/conversation-tag-input";
import { ConversationTagsContext } from "@redotech/redo-merchant-support-app/services/conversation-tags-service";
import { AddTagState } from "@redotech/redo-return-ui/flows/rules/add-tag";
import { RuleTypeDetailsProps } from "@redotech/redo-return-ui/flows/rules/multiple-actions";
import { memo, useMemo } from "react";

export const AddTagDetails = memo(function AddTagDetails({
  state,
  setState,
  disabled,
}: RuleTypeDetailsProps<AddTagState>) {
  const [conversationTags] = useLazyContext(ConversationTagsContext);
  // FIXME
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tagNames = new Set(state);
  const tags = useMemo(
    () => conversationTags.value?.filter((tag) => tagNames.has(tag.name)) || [],
    [conversationTags, tagNames],
  );

  return (
    <ConversationTagInput
      currentTags={tags}
      disabled={disabled}
      setCurrentTags={(tags) => setState(tags.map((tag) => tag.name))}
      showAddButtonToEnterInput
    />
  );
});
